export function LoadingPage({title='正在打开'}:{title?:string}) { return <main className="page loading" id="main" aria-busy="true" data-ready="false"><p className="eyebrow">Nook · 本机记录</p><h1>{title}</h1><p role="status">正在读取…</p></main>; }
